import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setIsParentPageSourceDatabase: YJSChangeHandler<
  DatabaseChangeType.SET_IS_PARENT_PAGE_SOURCE_DATABASE
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.isParentPageSourceDatabase = change.isParentPageSourceDatabase;
  });
};
